import { useEffect, useRef, useState } from 'react';
import { useTable, usePagination } from 'react-table';

// Ð¡ÐµÑÐ²ÐµÑÐ½Ð°Ñ ÑÐ°Ð±Ð»Ð¸ÑÐ° ÑÐ¾ ÑÑÑÐ°Ð½Ð¸ÑÐ°Ð¼Ð¸ Ð¸ Ð±ÑÑÑÑÑÐ¼ Ð¿Ð¾Ð¸ÑÐºÐ¾Ð¼: Ð¾Ð±ÑÐ°Ñ Ð¾Ð±Ð²ÑÐ·ÐºÐ° Ð²ÐºÐ»Ð°Ð´Ð¾Ðº ÑÑÑÐ½Ð¾Ð³Ð¾ ÑÐ¿Ð¸ÑÐºÐ°.
// fetcher({ page, pageSize, all }) â axios-Ð¾ÑÐ²ÐµÑ Ñ { [key]: [], pagination }; onData Ð²Ð¸Ð´Ð¸Ñ Ð²ÐµÑÑ Ð¾ÑÐ²ÐµÑ (sync Ð¸ Ñ.Ð¿.).
// reload â Ð»ÑÐ±Ð¾Ðµ Ð¼ÐµÐ½ÑÑÑÐµÐµÑÑ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ, Ð¿ÑÐ¸ ÑÐ¼ÐµÐ½Ðµ ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿ÐµÑÐµÑÐ¸ÑÑÐ²Ð°ÐµÑÑÑ.
const useServerTable = ({ fetcher, key, columns, reload = 0, onData }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  // ÐÐµÑÐ²Ð°Ñ Ð·Ð°Ð³ÑÑÐ·ÐºÐ°: Ð´Ð¾ Ð½ÐµÑ ÑÐ°Ð±Ð»Ð¸ÑÐ° ÑÐ¾ ÑÐ²Ð¾ÐµÐ¹ Ð¿Ð°Ð³Ð¸Ð½Ð°ÑÐ¸ÐµÐ¹ (Â«1 Ð¸Ð· 1Â») Ð½Ð°Ð´ ÑÐ¿Ð¸Ð½Ð½ÐµÑÐ¾Ð¼ Ð²ÑÐ³Ð»ÑÐ´Ð¸Ñ ÐºÐ°Ðº ÑÐ±Ð¾Ð¹
  const [loaded, setLoaded] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    pageSize: 10,
  });
  const [isFetchAll, setFetchAll] = useState(false);
  const [value, setValue] = useState('');
  const [queryParams, setQueryParams] = useState({});
  const onDataRef = useRef(onData);
  onDataRef.current = onData;

  const table = useTable(
    {
      columns,
      data: items,
      initialState: { pageSize: 10 },
      manualPagination: true,
      pageCount: pagination.totalPages,
      page: pagination.page - 1,
      disableSortRemove: true,
    },
    usePagination
  );

  useEffect(() => {
    if (isFetchAll) return;
    setLoading(true);
    fetcher({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams })
      .then((res) => {
        setItems(res?.data?.[key] || []);
        onDataRef.current?.(res?.data);
        // Ð§Ð¸ÑÐ°ÐµÐ¼ Ð´Ð¾ setPagination: Ð¸ÑÐºÐ»ÑÑÐµÐ½Ð¸Ðµ Ð²Ð½ÑÑÑÐ¸ Ð¾Ð±Ð½Ð¾Ð²Ð¸ÑÐµÐ»Ñ ÑÐ»ÑÑÐ°ÐµÑÑÑ Ð¿ÑÐ¸ ÑÐµÐ½Ð´ÐµÑÐµ Ð¸ ÑÐ¾Ð½ÑÐµÑ ÑÑÑÐ°Ð½Ð¸ÑÑ
        const next = res?.data?.pagination;
        if (next) {
          setPagination((prev) => ({ ...next, page: next.pageNumber, pageSize: prev.pageSize }));
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
        setLoaded(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.page, pagination.pageSize, queryParams, isFetchAll, reload]);

  const search = (text) => {
    setQueryParams({ all: (text || '').trim() });
    setPagination((prev) => ({ ...prev, page: 1 }));
  };

  // ÐÐ»Ñ <Table>: Ð¾Ð±ÑÐ¸Ðµ Ð¿ÑÐ¾Ð¿ÑÑ ÑÐµÑÐ²ÐµÑÐ½Ð¾Ð¹ ÑÐ°Ð±Ð»Ð¸ÑÑ
  const tableProps = {
    table,
    pagination: true,
    setPagination,
    setFetchAll,
    isFetchAll,
    setData: setItems,
    p: pagination,
    loading,
    setLoading,
    queryParams,
  };

  return {
    table,
    tableProps,
    loaded,
    loading,
    searching: !!queryParams.all,
    value,
    setValue,
    search,
    setPagination,
  };
};

export default useServerTable;
